import { useState } from 'react';
import { useModal } from '../../context/Modal/useModal';
import { useToast } from '../../context/Toast/useToast';
import Button, { ButtonType } from '../Button/Button';
import { ModalLayout } from './ModalLayout';

type ConfirmModalProps = {
  title: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
  confirmLabel: string;
  confirmingLabel?: string;
  cancelLabel: string;
  variant?: 'primary' | 'danger';
  onConfirm: () => Promise<string | void>;
};

export const ConfirmModal = ({
  title,
  description,
  children,
  confirmLabel,
  confirmingLabel,
  cancelLabel,
  variant = 'primary',
  onConfirm,
}: ConfirmModalProps) => {
  const { onClose } = useModal();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const onClickConfirm = () => {
    setIsLoading(true);
    onConfirm()
      .then((message) => {
        if (message) {
          toast.addToast({ message, type: 'success' });
        }
        onClose();
      })
      .catch((e: Error) => {
        toast.addToast({ message: e.message, type: 'error' });
        setIsLoading(false);
      });
  };

  return (
    <ModalLayout
      title={title}
      size="sm"
      description={description}
      footer={
        <>
          <Button
            onClick={onClose}
            type={ButtonType.Secondary}
            disabled={isLoading}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={onClickConfirm}
            type={
              variant === 'danger'
                ? ButtonType.PrimaryDanger
                : ButtonType.Primary
            }
            loading={isLoading}
            loadingText={confirmingLabel}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {children}
    </ModalLayout>
  );
};
